import { render } from "./ckeditor.vue?vue&type=template&id=ab4b087c"
import script from "./ckeditor.vue?vue&type=script&lang=js"
export * from "./ckeditor.vue?vue&type=script&lang=js"

import "./ckeditor.vue?vue&type=style&index=0&id=ab4b087c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__